/**
 * Billing Page (INERT STUB)
 * 
 * Per PHASE_B_WORK_ORDERS.md B8:
 * - Owner-only access
 * - Static copy: "Billing will be enabled in a future release"
 * - NO Stripe SDK, webhooks, or payment paths
 */

export default function BillingPage() {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-neutral-900">Billing</h1>
        <p className="mt-2 text-sm text-neutral-600">
          Route: /app/billing | Status: Authenticated | Access: Owner only
        </p>
      </div>
      
      <div className="bg-white border border-neutral-200 rounded-lg p-8 text-center">
        <div className="max-w-md mx-auto">
          <h2 className="text-xl font-semibold text-neutral-900 mb-4">
            Billing
          </h2>
          <p className="text-neutral-600">
            Billing will be enabled in a future release.
          </p>
        </div>
      </div>
    </div>
  );
}
